/// <reference path="index.d.ts" />
import 'core-js/stable';
import './less/styling.less';
import { isCordova, fullUserAgent } from 'utils/platform';
import 'utils/CustomEventPolyfill';
import { WlWindow } from 'typings/globals/cordova';
import useAuthStore from '~/authentication/store';
declare const window: WlWindow;
function loadMain() {
  const Main = require('./Main').default;
  const UI = require('./ui').default;
  Main();
  UI();
  if (isCordova()) {
    console.log('cookies cordova', window.document.cookie);
    window.UserAgent.get(() => window.UserAgent.set(fullUserAgent()));
    window.open = window.cordova.InAppBrowser.open;
    (async () => {
      await useAuthStore.persist.rehydrate();
    })();
  }
  console.log('loaded main and UI');
}

if (isCordova()) {
  document.addEventListener('deviceready', loadMain, false);
} else {
  loadMain();
}

